<div>
  <app-title-content-widget [title]="title" [widgetPanel]="widgetPanel">
    <ng-template #titleContentPanel>
      <div class="col g-0 h-100">
        <div class="inner-panel">
          @if (widgetPanelListItems.data.length > 0) {
            <ul>
              @for (listItem of widgetPanelListItems.data; track listItem) {
                <li class="panel-row-list-item">
                  @if (!listItem.isClickable) {
                    <span [ngClass]="listItem.class || ''"
                      ><span class="list-item-header"
                        >{{ listItem.title }} </span
                      >{{ listItem.content }}</span
                    >
                  }
                  @if (listItem.isClickable) {
                    <a
                      [ngClass]="listItem.class || ''"
                      href="javascript:void(0)"
                      (click)="itemClick.emit(listItem)"
                      ><span class="list-item-header"
                        >{{ listItem.title }} </span
                      >{{ listItem.content }}</a
                    >
                  }
                </li>
              }
            </ul>
          }
          @if (widgetPanelListItems.data.length === 0) {
            <div class="d-flex justify-content-center">
              <label>{{ widgetPanelListItems.noDataMessage }}</label>
            </div>
          }
        </div>
      </div>
    </ng-template>
  </app-title-content-widget>
</div>
